module.exports = __webpack_public_path__ + "media/tase/bghead-old-61592b27.png";